import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s20" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "table separator skin1 selection" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "font-normal" }

import { onMounted, ref } from 'vue';
    import axios from 'axios';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionsListView',
  setup(__props) {

    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);

    onMounted(() => {
        doListPermissions();
    });

    async function doListPermissions() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/permissions/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[0] || (_cache[0] = _createTextVNode("Permissions ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(itemsList.value.length) + ")", 1)
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "clear-both" }, null, -1))
          ]),
          _createElementVNode("table", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { width: "50px" }),
                _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Libellé")
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Module")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (itemsList.value.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("td", { colspan: "3" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'role_' + index,
                  class: "text-grey-700 over-effect over-effect-scale"
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                    _createElementVNode("div", {
                      class: "square-lg px-3 py-3",
                      style: {"background-color":"rgb(var(--color-success-rgb), 0.1)"}
                    }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-role.svg",
                        width: "100%"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", null, _toDisplayString(item.label), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h6", _hoisted_10, _toDisplayString(item.module), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})